import { render, staticRenderFns } from "./PostExplain.vue?vue&type=template&id=53eb1d86&scoped=true"
import script from "./PostExplain.vue?vue&type=script&lang=js"
export * from "./PostExplain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb1d86",
  null
  
)

export default component.exports